import { Button, ButtonProps } from '@revenuemarket/cds';
import { useTradeAllowed } from '~hooks/tax-invoice/useTradeAllowed';
import { useCompanyId } from '~hooks/useCompanyId';

interface TradeRevenueButtonProps extends ButtonProps {
  title: string;
  onClick: () => void;
  style?: React.CSSProperties;
}

const TradeRevenueButton = ({ title, ...props }: TradeRevenueButtonProps) => {
  const { companyId } = useCompanyId();
  const isDisabled = !useTradeAllowed(companyId);

  return (
    <Button
      style={{
        width: '100%',
      }}
      buttonSize="large"
      disabled={isDisabled}
      disable={isDisabled}
      {...props}
    >
      {title}
    </Button>
  );
};

export default TradeRevenueButton;
